const boundsToSearchArray = function(googleBoundsObj) {
  var latLonStr = googleBoundsObj.toString();
    latLonStr = latLonStr.replace(/[()\s]/g, "");
    var latLonArr = latLonStr.split(",");
    // latLonArr result from Google: [swLat, swLng, neLat, neLng]
    var latNW = latLonArr[2]; //same as neLat
    var lonNW = latLonArr[1]; //same as swLng
    var latSE = latLonArr[0]; //same as swLat
    var lonSE = latLonArr[3]; //same as neLng
    // search takes: [lat-nw,lon-nw, lat-se, lon-se]
    var requestArray = [latNW, lonNW, latSE, lonSE];
    var stringArr = "[" + requestArray + "]";
    return stringArr;
};


const geoCode = async (placeId, location) => {
  return new Promise((resolve, reject) => {
    const geoCoder = () => new google.maps.Geocoder();

    geoCoder().geocode({ placeId },
      (results) => {
        if (!results.length) {
          // This is a remenant from an old code, but want to keep it around,
          // because I do not know when it would happen, or how results can be 0 items
          return reject();
        }
        const queryObj = placeId ? { place_id: placeId } : {};
        queryObj.location = location.replace(/\,\s/g, '--').replace(/\s/g, '-');
        const geom = results[0].geometry;
        const lat = geom.location.lat();
        const lng = geom.location.lng();
        const POITypes = ['ROOFTOP', 'RANGE_INTERPOLATED'];
        if (-1 !== POITypes.indexOf(geom.location_type)) {
          queryObj.point_of_interest = `[${[lat, lng]}]`;
        } else if (geom.viewport) {
          queryObj.bbox_of_interest = boundsToSearchArray(geom.viewport);
        } else {
          return reject({
            results,
            queryObj,
            latitude: lat,
            longitude: lng
          });
        }
        return resolve({
          results,
          queryObj,
          latitude: lat,
          longitude: lng
        });
      }
    );
  })
};

export default geoCode;
